import { render } from "./Projections.vue?vue&type=template&id=536cfbb2"
import script from "./Projections.vue?vue&type=script&setup=true&lang=js"
export * from "./Projections.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Results/Projections.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "536cfbb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('536cfbb2', __exports__)) {
    api.reload('536cfbb2', __exports__)
  }
  
  module.hot.accept("./Projections.vue?vue&type=template&id=536cfbb2", () => {
    api.rerender('536cfbb2', render)
  })

}


export default __exports__